/**
 * Internal/demo staff emails — used to skip official customer login/tour tracking
 * and operational Slack pages (e.g. #full-account-setup).
 *
 * Domains: @searchbubble.com, @browsable.ai
 * Also: any address whose local-part contains "sbtesting" (QA accounts on any domain).
 */
export function isInternalStaffEmail(email: string): boolean {
  const lower = String(email || "").trim().toLowerCase();
  if (!lower) return false;

  if (lower.endsWith("@searchbubble.com") || lower.endsWith("@browsable.ai")) {
    return true;
  }

  const localPart = lower.split("@")[0] || "";
  return localPart.includes("sbtesting");
}

/**
 * Patch for `user.website_demo` on onboard — staff emails only (new accounts).
 * Does not change Stripe / dashboard plan entitlements for normal creators.
 */
export function websiteDemoOnboardPatch(
  email: string,
): { website_demo: true } | Record<string, never> {
  return isInternalStaffEmail(email) ? { website_demo: true } : {};
}
